module.exports = __webpack_public_path__ + "1db457cc76a1753cc9e755a9f85fbae4.png";